import client from "./axios";

// FB Graph API (graph.facebook.com) data, proxied through our backend which holds
// the page access token + connected Instagram account id.
const ENV = `${process.env.REACT_APP_BACKEND_URL}/facebook`;

/** List the user's connected Facebook pages. */
export const getFacebookPages = async () => {
  const response = await client.get(`${ENV}/pages`);
  return response.data;
};

/** Connected Instagram professional account profile. */
export const getFacebookProfile = async () => {
  const response = await client.get(`${ENV}/profile`);
  return response.data;
};

/**
 * Tagged posts/reels, served from the backend cache so the tab paints instantly.
 * `{ data: [], cached, account }`.
 */
export const getFacebookMentions = async () => {
  const response = await client.get(`${ENV}/mentions`);
  return response.data;
};

/**
 * Re-pull tagged media from the Graph API, update the cache, return fresh rows.
 * Slower — use for an explicit Refresh. `{ data: [], refreshed }`.
 */
export const refreshFacebookMentions = async () => {
  const response = await client.post(`${ENV}/mentions/refresh`);
  return response.data;
};

/**
 * Set a tagged post's boost-permission status.
 * @param status "requested" | "accepted" | "rejected" | "none"
 */
export const setMentionAdStatus = async (mediaId: string, status: string) => {
  const response = await client.post(`${ENV}/mentions/${mediaId}/status`, {
    status,
  });
  return response.data;
};

/** Instagram DM conversations on the connected page. `{ data: [] }`. */
export const getFacebookConversations = async () => {
  const response = await client.get(`${ENV}/conversations`);
  return response.data;
};

/** Account insights (reach, engagement, ...). `{ data: [], error? }`. */
export const getFacebookInsights = async () => {
  const response = await client.get(`${ENV}/insights`);
  return response.data;
};

/** Public stats for any Instagram account by username. `{ data }`. */
export const getFacebookBusinessDiscovery = async (username: string) => {
  const response = await client.get(`${ENV}/business-discovery`, {
    params: { username },
  });
  return response.data;
};
